import { Collection, Ref, RefNumber, RefObject } from "@tblabs/truffle";
import { DeviceConfig } from "./DeviceConfig";
import { ConnectionStatus } from "./DeviceConnectionStatus";
import { PictureSettings } from "./PictureSettings";
import { RawDeviceProfile } from "./RawDeviceProfile";
import { WatcherProfile } from "./WatcherProfile";
import { DeviceRecord } from "./DeviceRecord";
import { PictureForWebClient } from "./PictureForWebClient";
import { IoState } from "../Services/IoState";

/*
    SYNC TO SERVER 
*/
export class Stats
{
    public PicturesCount = new RefNumber();
    public PicturesSize = new RefNumber();
    public RebootsCount = new RefNumber();
}

export interface Malfunctions
{
    Inputs: string[];
}

/*
    SYNC TO SERVER 
*/
export class DeviceProfile
{
    public Id: string;
    public Version: string;
    public ConnectionStatus = new Ref<ConnectionStatus>(ConnectionStatus.Unset);
    public Password = new Ref<string>("");
    public Watchers = new Collection<WatcherProfile>();
    public Config: DeviceConfig;
    public Stats = new Stats();
    public Thumbnail = new RefObject<PictureForWebClient | null>(null);
    public Record: DeviceRecord;
    public IoState: IoState;

    constructor(raw: RawDeviceProfile)
    {
        this.Update(raw);
    }
    
    public Update(profile: RawDeviceProfile): void
    {
        this.Id = profile.Id;
        this.Version = profile.Version;
        this.ConnectionStatus.value = profile.ConnectionStatus;
        this.Password.value = profile.Password;
        this.Watchers.Load(...profile.Watchers.map(x => new WatcherProfile(x)));
        this.Stats.PicturesCount.value = profile.Stats.PicturesCount;
        this.Stats.PicturesSize.value = profile.Stats.PicturesSize;
        this.Stats.RebootsCount.value = profile.Stats.RebootsCount;
        this.Thumbnail.object = profile.Thumbnail;
        this.Config = profile.Config;
        this.Record = profile.Record;
        this.IoState = profile.IoState;
    }

    public get IsLocked(): boolean
    {
        return this.Password.value.endsWith("defpass");
    }

    public get PictureConfig(): PictureSettings
    {
        return this.Config?.picture;
    }
}
